<template>
  <canvas
    v-if="getHasFrame"
    v-show="0"
    id="canvasImage"
    ref="canvasImage"
    :width="getWidth"
    :height="getHeight"
  ></canvas>
  <svg
    v-if="getHasFrame"
    id="svgCanvas"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    :width="getSVGSize.width"
    :height="getSVGSize.height"
    :viewBox="getSvgViewBox"
    style=""
    xml:space="preserve"
  >
    <defs>
      <pattern
        id="top"
        xmlns="http://www.w3.org/2000/svg"
        patternUnits="userSpaceOnUse"
        :width="getTextureWidth"
        :height="getTextureHeight"
      >
        <image
          xmlns="http://www.w3.org/2000/svg"
          :href="getBase64ImageTexture"
          :height="getTextureHeight"
          :width="getTextureWidth"
        />
      </pattern>
      <pattern
        id="left"
        xmlns="http://www.w3.org/2000/svg"
        patternUnits="userSpaceOnUse"
        :width="getTextureHeight"
        :height="getTextureWidth"
      >
        <g :transform="getTransformRight">
          <image
            transform="rotate(-90)"
            xmlns="http://www.w3.org/2000/svg"
            :href="getBase64ImageTexture"
            :height="getTextureHeight"
            :width="getTextureWidth"
          />
        </g>
      </pattern>
      <pattern
        id="bottom"
        xmlns="http://www.w3.org/2000/svg"
        patternUnits="userSpaceOnUse"
        :width="getTextureWidth"
        :height="getTextureHeight"
      >
        <g :transform="getTransformBottom">
          <image
            transform="rotate(180)"
            xmlns="http://www.w3.org/2000/svg"
            :href="getBase64ImageTexture"
            :height="getTextureHeight"
            :width="getTextureWidth"
          />
        </g>
      </pattern>
    </defs>
    <g id="Layer_1">
      <polyline
        xmlns="http://www.w3.org/2000/svg"
        fill="url(#top)"
        class="st0"
        style="stroke-width: 0px"
        :points="getTopPath"
      />
    </g>
    <g id="Layer_2">
      <polyline
        xmlns="http://www.w3.org/2000/svg"
        fill="url(#left)"
        class="st0"
        :points="getLeftPath"
        style="stroke-width: 0px"
      />
    </g>
    <g id="Layer_3">
      <g :transform="getTransformBottom">
        <polyline
          transform="scale(1,-1)"
          xmlns="http://www.w3.org/2000/svg"
          fill="url(#top)"
          class="st0"
          style="stroke-width: 0px"
          :points="getTopPath"
        />
      </g>
    </g>
    <g id="Layer_4">
      <g :transform="getTransformLeft">
        <polyline
          transform="scale(-1,-1)"
          xmlns="http://www.w3.org/2000/svg"
          fill="url(#left)"
          class="st0"
          style="stroke-width: 0px"
          :points="getLeftPath"
        />
      </g>
    </g>
  </svg>
</template>
<script>
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { useEditorFilesStore } from "@/stores/modules/editorFiles";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";
import * as R from "ramda";

export default {
  components: {},
  computed: {
    ...mapState(useImageEditorStore, [
      "getImage",
      "canvasFormatDimByFormat",
      "getReady",
      "getFullFormatDim",
      "getEditor",
      "getHasWhiteMargin"
    ]),
    ...mapState(useWebproductStore, ["getHasFrameOptions"]),
    zoom: function () {
      return this.getEditor.zoom;
    },
    unit: function () {
      var imageUnit = this.getEditor.dim.imageDimByFormat.unit;
      var canvasUnit = this.getEditor.dim.canvasDimByFormat.unit;
      return imageUnit / canvasUnit;
    },
    focalPoint: function () {
      return this.getEditor.focalPoint;
    },
    getTextureHeight: function () {
      return this.getMarginValue;
    },
    marginView: function () {
      return this.getEditor.marginView;
    },

    getWidth: function () {
      if (this.getReady) {
        var size = this.getCanvasSize;
        var marginValue = this.getMarginValue;
        var tmp = this.getEditor.dim.canvasImageDimByFormat;
        var hasWhiteMargin = this.getHasWhiteMargin;
        if (hasWhiteMargin) {
          return Math.round(size.width) + marginValue * 2;
        }
        return Math.round(size.width) + marginValue * 2;
      }
      return 0;
    },
    getHeight: function () {
      if (this.getReady) {
        var size = this.getCanvasSize;
        var marginValue = this.getMarginValue;
        var tmp = this.getEditor.dim.canvasImageDimByFormat;
        var hasWhiteMargin = this.getHasWhiteMargin;
        if (hasWhiteMargin) {
          return Math.round(size.height) + marginValue * 2;
        }
        return Math.round(size.height) + marginValue * 2;
      }
      return 0;
    },
    getHasFrame: function () {
      return this.getHasFrameOptions.hasFrame;
    },
    getMarginValue: function () {
      if (this.getHasFrame) {
        var margin = this.getHasFrameOptions.imageData.border_width;
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var finalHeight = lfpGlobalStore.format.height;
        var height = size1.height;
        return (margin * height) / finalHeight;
      }
      return 0;
    },
    getTopPath: function () {
      var size = this.getSVGSize;
      var marginValue = this.getMarginValue;
      return (
        "0 0 " +
        marginValue +
        " " +
        marginValue +
        " " +
        (size.width - marginValue) +
        " " +
        marginValue +
        " " +
        size.width.toString() +
        " 0"
      );
    },
    getRightPath: function () {
      var size = this.getSVGSize;
      var marginValue = this.getMarginValue;
      return (
        size.width +
        " 0 " +
        (size.width - marginValue) +
        " " +
        marginValue +
        " " +
        (size.width - marginValue) +
        " " +
        (size.height - marginValue) +
        " " +
        size.width +
        " " +
        size.height
      );
    },
    getBottomPath: function () {
      var size = this.getSVGSize;
      var marginValue = this.getMarginValue;
      return (
        size.width +
        "  " +
        size.height +
        " " +
        (size.width - marginValue) +
        " " +
        (size.height - marginValue) +
        " " +
        marginValue +
        " " +
        (size.height - marginValue) +
        " 0 " +
        size.height
      );
    },
    getTransformRight: function () {
      var size = this.getSVGSize;
      var marginValue = this.getMarginValue;
      return "translate(0," + this.getTextureWidth + ")";
    },
    getTransformBottom: function () {
      var size = this.getSVGSize;
      var marginValue = this.getMarginValue;
      return "scale(1,1) translate(0," + this.getSVGSize.height + ")";
    },
    getTransformLeft: function () {
      var size = this.getSVGSize;
      var marginValue = this.getMarginValue;
      return (
        "scale(1,1) translate(" +
        this.getSVGSize.width +
        " " +
        this.getSVGSize.height +
        ")"
      );
    },
    getOriginalTextureDim: function () {
      if (this.getHasFrame) {
        return this.getHasFrameOptions.imageData.texture_border;
      }
      return {
        width: 0,
        height: 0
      };
    },
    getTextureWidth: function () {
      var originalDimTexture = this.getOriginalTextureDim;
      var ratio = originalDimTexture.width / originalDimTexture.height;
      return this.getTextureHeight * ratio;
    },
    getBase64ImageTexture: function () {
      if (this.getHasFrame) {
        return this.getHasFrameOptions.imageData.texture_border.url;
      }
      return "";
    },
    getLeftPath: function () {
      var size = this.getSVGSize;
      var marginValue = this.getMarginValue;
      return (
        "0" +
        "  " +
        size.height +
        " " +
        marginValue +
        " " +
        (size.height - marginValue) +
        " " +
        marginValue +
        " " +
        marginValue +
        " 0 0"
      );
    },
    getSVGSize: function () {
      if (this.getReady) {
        var marginValue = this.getMarginValue;
        var size = this.getCanvasSize;
        return {
          width: parseFloat(size.width) + marginValue * 2,
          height: parseFloat(size.height) + marginValue * 2
        };
      }
      return {
        width: 0,
        height: 0
      };
    },
    getCanvasSize: function () {
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        return {
          width: width,
          height: height
        };
      }
      return {
        width: 0,
        height: 0
      };
    },
    getSvgViewBox: function () {
      {
        if (this.getReady) {
          var size = this.getSVGSize;
          return (
            "0 0 " + parseFloat(size.width) + " " + parseFloat(size.height)
          );
        }
      }
      return "0 0 0 0";
    },
    fullFormat: function () {
      return this.canvasFormatDimByFormat;
    },
    formatChanges: function () {
      return this.fullFormat;
    },
    variablesWatch: function () {
      return [
        this.getEditor.dim.canvasImageDimByFormat,
        this.getHasFrameOptions
      ];
    }
  },
  methods: {
    ...mapActions(useImageEditorStore, ["updateBgOnResize", "setCanvasImage"]),
    getRotateDimensionsEnlarged: function (image) {
      image.rotate_angle = lfpGlobalStore.getRotateAngle;
      var editorCanvasByFormat = lfpGlobalStore.editor.dim.canvasDimByFormat;
      var canvasUnit = lfpGlobalStore.editor.dim.canvasDimByFormat.unit;
      var canvasFormatDimByFormat = lfpGlobalStore.canvasFormatDimByFormat;
      var zoom = lfpGlobalStore.editor.zoom / 100;
      var originalImageSize = lfpGlobalStore.originalImageSize;
      var width = canvasFormatDimByFormat.width_fix * canvasUnit;
      var height = canvasFormatDimByFormat.height_fix * canvasUnit;
      var cLeft = canvasFormatDimByFormat.left * canvasUnit;
      var cTop = canvasFormatDimByFormat.top * canvasUnit;
      var cBottom = canvasFormatDimByFormat.bottom * canvasUnit;
      var cRight = canvasFormatDimByFormat.right * canvasUnit;
      var zoomW = width / zoom;
      var zoomH = height / zoom;
      var centerW = editorCanvasByFormat.width_fix / 2;
      var centerH = editorCanvasByFormat.height_fix / 2;
      var focalPoint = lfpGlobalStore.editor.focalPoint;
      var left = ((focalPoint.x * zoom - centerW) * canvasUnit + cLeft) / zoom;
      var top = ((focalPoint.y * zoom - centerH) * canvasUnit + cTop) / zoom;
      var right =
        ((focalPoint.x * zoom - centerW) * canvasUnit + cRight) / zoom;
      var bottom =
        ((focalPoint.y * zoom - centerH) * canvasUnit + cBottom) / zoom;
      var rLeft =
        (((centerW - focalPoint.x + centerW) * zoom - centerW) * canvasUnit +
          cLeft) /
        zoom;
      var rTop =
        (((centerH - focalPoint.y + centerH) * zoom - centerH) * canvasUnit +
          cTop) /
        zoom;
      var rRight =
        (((centerW - focalPoint.x + centerW) * zoom - centerW) * canvasUnit +
          cRight) /
        zoom;
      var rBottom =
        (((centerH - focalPoint.y + centerH) * zoom - centerH) * canvasUnit +
          cBottom) /
        zoom;
      var dimmensions = {
        left: left,
        top: top,
        bottom: bottom,
        right: right,
        rLeft: rLeft,
        rTop: rTop,
        rBottom: rBottom,
        rRight: rRight,
        width: zoomW,
        height: zoomH
      };
      switch (image.rotate_angle) {
        case 90:
          image.cropX = dimmensions.top;
          image.cropY = dimmensions.rRight;
          image.cropW = dimmensions.height;
          image.cropH = dimmensions.width;
          break;
        case 180:
          image.cropX = dimmensions.rRight;
          image.cropY = dimmensions.rBottom;
          image.cropW = dimmensions.width;
          image.cropH = dimmensions.height;
          break;
        case 270:
          image.cropX = dimmensions.rBottom;
          image.cropY = dimmensions.left;
          image.cropW = dimmensions.height;
          image.cropH = dimmensions.width;
          break;
        default:
          image.cropX = dimmensions.left;
          image.cropY = dimmensions.top;
          image.cropW = dimmensions.width;
          image.cropH = dimmensions.height;
          break;
      }
      return image;
    },
    getRotateDimensionsWithMargins: function (image) {
      image.rotate_angle = lfpGlobalStore.getRotateAngle;
      var pdfUnit = lfpGlobalStore.pdfUnit;
      var canvasUnit = lfpGlobalStore.editor.dim.canvasDimByFormat.unit;
      var margin = lfpGlobalStore.getMarginsWithThickness;
      var canvasFormatDimByFormat = lfpGlobalStore.canvasFormatDimByFormat;
      var editorCanvasByFormat = lfpGlobalStore.editor.dim.canvasDimByFormat;
      var zoom = lfpGlobalStore.editor.zoom / 100;
      var originalImageSize = lfpGlobalStore.originalImageSize;
      var cLeft = canvasFormatDimByFormat.left * canvasUnit;
      var cTop = canvasFormatDimByFormat.top * canvasUnit;
      var cBottom = canvasFormatDimByFormat.bottom * canvasUnit;
      var cRight = canvasFormatDimByFormat.right * canvasUnit;
      var width =
        canvasFormatDimByFormat.width_fix * canvasUnit -
        margin.left * pdfUnit -
        margin.right * pdfUnit;
      var height =
        canvasFormatDimByFormat.height_fix * canvasUnit -
        margin.top * pdfUnit -
        margin.bottom * pdfUnit;
      var zoomW = width / zoom;
      var zoomH = height / zoom;

      var centerW = editorCanvasByFormat.width_fix / 2;
      var centerH = editorCanvasByFormat.height_fix / 2;
      var focalPoint = lfpGlobalStore.editor.focalPoint;
      var left = ((focalPoint.x * zoom - centerW) * canvasUnit + cLeft) / zoom;
      var top = ((focalPoint.y * zoom - centerH) * canvasUnit + cTop) / zoom;
      var right =
        ((focalPoint.x * zoom - centerW) * canvasUnit + cRight) / zoom;
      var bottom =
        ((focalPoint.y * zoom - centerH) * canvasUnit + cBottom) / zoom;
      left = left + (margin.left * pdfUnit) / zoom;
      top = top + (margin.top * pdfUnit) / zoom;
      var rLeft =
        (((centerW - focalPoint.x + centerW) * zoom - centerW) * canvasUnit +
          cLeft) /
        zoom;
      var rTop =
        (((centerH - focalPoint.y + centerH) * zoom - centerH) * canvasUnit +
          cTop) /
        zoom;
      var rRight =
        (((centerW - focalPoint.x + centerW) * zoom - centerW) * canvasUnit +
          cRight) /
        zoom;
      var rBottom =
        (((centerH - focalPoint.y + centerH) * zoom - centerH) * canvasUnit +
          cBottom) /
        zoom;
      rRight =
        rRight -
        margin.left * pdfUnit -
        margin.right * pdfUnit +
        (margin.right * pdfUnit) / zoom;
      rBottom =
        rBottom -
        margin.bottom * pdfUnit -
        margin.top * pdfUnit +
        (margin.bottom * pdfUnit) / zoom;
      var dimmensions = {
        left: left,
        top: top,
        bottom: bottom,
        right: right,
        rLeft: rLeft,
        rTop: rTop,
        rRight: rRight,
        rBottom: rBottom,
        width: zoomW,
        height: zoomH
      };
      image = this.getRotate(image, dimmensions);
      return image;
    },
    getRotate: function (image, dimmensions) {
      switch (image.rotate_angle) {
        case 90:
          image.cropX = dimmensions.top;
          image.cropY = dimmensions.rRight;
          image.cropW = dimmensions.height;
          image.cropH = dimmensions.width;
          break;
        case 180:
          image.cropX = dimmensions.rRight;
          image.cropY = dimmensions.rBottom;
          image.cropW = dimmensions.width;
          image.cropH = dimmensions.height;
          break;
        case 270:
          image.cropX = dimmensions.rBottom;
          image.cropY = dimmensions.left;
          image.cropW = dimmensions.height;
          image.cropH = dimmensions.width;
          break;
        default:
          image.cropX = dimmensions.left;
          image.cropY = dimmensions.top;
          image.cropW = dimmensions.width;
          image.cropH = dimmensions.height;
          break;
      }
      return image;
    },
    setImagesForload: function () {
      var lfpImage = this.getImage;
      this.imagesToLoad = [];
      if (this.t) {
        clearInterval(this.t);
      }
      lfpImage.resized.src;
      var svg = document.getElementById("svgCanvas");
      if (!svg) {
        return false;
      }
      var xml = new XMLSerializer().serializeToString(svg);
      var svg64 = btoa(xml);
      var b64Start = "data:image/svg+xml;base64,";
      // prepend a "header"
      var image64 = b64Start + svg64;
      var imagesToLoad = {
        main: {
          src: lfpImage.resized.src,
          loaded: 0
        },
        svg: {
          src: image64,
          loaded: 0
        },
        objects: {
          images: [],
          loaded: 1
        }
      };
      R.forEachObjIndexed((object, key) => {
        if (
          object["type"] === "image" &&
          object["subtype"] === "cropimage" &&
          object.cropData
        ) {
          var rotateAngle = ((object.angle * 180) / Math.PI) % 360;
          var left = (object.left - object.offsetX) * this.unit;
          var top = (object.bottom - object.offsetY) * this.unit;
          var width = object.width * this.unit;
          var height = object.height * this.unit;
          var item = {
            left: left,
            top: top,
            width: width,
            height: height,
            cropX: object.cropData.x,
            cropY: object.cropData.y,
            cropW: object.cropData.width,
            cropH: object.cropData.height,
            scaleX: object.cropData.scaleX,
            rotateAngle: rotateAngle
          };
          var imageObj = document.querySelector(
            ".itemno" + object.uuid + " img"
          );
          if (imageObj) {
            item.imageObj = imageObj;
            imagesToLoad["objects"]["images"].push(item);
          }
        }
      }, lfpGlobalStore.object.objects);
      var main = new Image();
      var svgImage = new Image();
      this.imagesToLoad = imagesToLoad;

      main.onload = (function (that) {
        return function () {
          that.imagesToLoad["main"].loaded = 1;
          that.imagesToLoad["main"].imageObj = this;
        };
      })(this);
      svgImage.onload = (function (that) {
        return function () {
          that.imagesToLoad["svg"].loaded = 1;
          that.imagesToLoad["svg"].imageObj = this;
        };
      })(this);
      main.src = lfpImage.resized.src;
      svgImage.src = image64;
      clearInterval(this.t);
      this.t = setInterval(
        (function (that) {
          return function () {
            if (
              that.imagesToLoad.main.loaded &&
              that.imagesToLoad.svg.loaded &&
              !that.run
            ) {
              clearInterval(that.t);
              that.run = 1;
              that.drawImageCanvas();
            }
          };
        })(this),
        100
      );
    },
    drawImageCanvas: function () {
      this.run = 1;
      var lfpImage = this.getImage;
      var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
      var tmp = this.getEditor.dim.canvasImageDimByFormat;
      var margin = lfpGlobalStore.getMarginsWithThickness;
      var hasWhiteMargin = this.getHasWhiteMargin;
      var size = {
        bottom: tmp.bottom,
        height: tmp.height,
        left: tmp.left,
        right: tmp.right,
        top: tmp.top,
        width: tmp.width
      };
      var zoom = this.zoom / 100;

      var left =
        Math.round(this.focalPoint.x * zoom - editorCanvasByFormat.width / 2) *
        -1;
      var top =
        Math.round(this.focalPoint.y * zoom - editorCanvasByFormat.height / 2) *
        -1;

      var zoomW = Math.round(size.width * zoom);
      var zoomH = Math.round(size.height * zoom);
      const canvasImageOrig = document.getElementById("canvasImage");
      let canvasImage = document.createElement("CANVAS");
      canvasImage.width = canvasImageOrig.width;
      canvasImage.height = canvasImageOrig.height;
      var ctx = canvasImage.getContext("2d");
      var img = this.imagesToLoad["main"].imageObj;
      var canvasUnit = lfpGlobalStore.editor.dim.canvasDimByFormat.unit;
      if (margin.type < 0) {
        var imageDimensions = this.getRotateDimensionsEnlarged({});
      } else {
        var imageDimensions = this.getRotateDimensionsWithMargins({});
      }
      var originalWidth = lfpImage.original.width;
      var resizedWidth = lfpImage.resized.width;
      var originalHeight = lfpImage.original.height;
      var resizedHeight = lfpImage.resized.height;
      var scaleWidth = resizedWidth / originalWidth;
      var scaleHeight = resizedHeight / originalHeight;
      var marginValue = this.getMarginValue;
      var sizeSvg = this.getSVGSize;
      ctx.clearRect(0, 0, canvasImage.width, canvasImage.height);
      ctx.drawImage(
        img,
        imageDimensions.cropX * scaleWidth,
        imageDimensions.cropY * scaleHeight,
        imageDimensions.cropW * scaleWidth,
        imageDimensions.cropH * scaleHeight,
        marginValue,
        marginValue,
        canvasImage.width - marginValue * 2,
        canvasImage.height - marginValue * 2
      );
      // prepend a "header"
      var imgXml = this.imagesToLoad["svg"].imageObj;
      var sizeSvg2 = sizeSvg;
      var canvasImage2 = canvasImage;
      R.forEach(item => {
        ctx.save();
        var imageObj = item.imageObj;
        // ctx.save();
        var adjustLeft = 0;
        var adjustTop = 0;
        if (hasWhiteMargin) {
          var adjustLeft = tmp.left;
          var adjustTop = tmp.top;
        }
        // move to the center of the canvas
        var leftTranslate =
          item.left + marginValue + adjustLeft + item.width / 2;
        var topTranslate =
          canvasImage.height -
          (item.top + item.height + marginValue + adjustTop) +
          item.height / 2;
        ctx.translate(leftTranslate, topTranslate);
        // rotate the canvas to the specified degrees
        ctx.rotate((item.rotateAngle * Math.PI) / 180);

        ctx.drawImage(
          imageObj,
          item.cropX,
          item.cropY,
          item.cropW,
          item.cropH,
          -1 * leftTranslate + item.left + marginValue + adjustLeft,

          -1 * topTranslate +
            canvasImage.height -
            (item.top + item.height + marginValue + adjustTop),
          item.width,
          item.height
        );
        ctx.restore();
      }, this.imagesToLoad.objects.images);

      if (hasWhiteMargin) {
        ctx.save();
        ctx.rect(
          marginValue,
          marginValue,
          canvasImage.width - marginValue * 2,
          tmp.whitetop
        );
        ctx.rect(
          canvasImage.width - marginValue - tmp.whiteright,
          marginValue,
          tmp.whiteright,
          canvasImage.height - marginValue * 2
        );
        ctx.rect(
          marginValue,
          canvasImage.height - marginValue - tmp.whitebottom,
          canvasImage.width - marginValue * 2,
          tmp.whitebottom
        );
        ctx.rect(
          marginValue,
          marginValue,
          tmp.whiteleft,
          canvasImage.height - marginValue * 2
        );
        ctx.fillStyle = "#fff";
        ctx.fill();
        //  ctx.restore();
      }
      ctx.drawImage(
        imgXml,
        0,
        0,
        sizeSvg2.width,
        sizeSvg2.height,
        0,
        0,
        canvasImage2.width,
        canvasImage2.height
      );

      this.setCanvasImage({
        base64: canvasImage.toDataURL()
      });
      this.run = 0;
    }
  },
  mounted: function () {},
  updated: function () {
    this.$nextTick(function () {
      if (this.getHasFrame) {
        this.setImagesForload();
      }
      // Code that will run only after the
      // entire view has been re-rendered
    });
  },
  watch: {
    marginView: {
      handler: function () {
        if (this.getHasFrame) {
          this.setImagesForload();
        }
      },
      deep: false
    },
    variablesWatch: {
      handler: function () {
        if (this.getHasFrame) {
          this.setImagesForload();
        }
      },
      deep: false
    }
  }
};
</script>
